<template>
	<UiLoader class="spacing" />
</template>

<script setup>
	import Keycloak from 'keycloak-js';
	const endpoints = useEndpoints();
	const apiToken = useToken();
	const config = useAppConfig();

	onMounted(async () => {
		await useApi(`${endpoints.get('_post_hapi_auth_api_config')}`, {
			method: 'POST',
			body: {success_url: "/uporabnik/"},
		}).then(async (res) => {
			if(res.success) {
				var keycloak2 = new Keycloak({
					url: res.data.config.url,
					realm: res.data.config.username,
					clientId: res.data.config.client_id
				});
				console.debug('keycloak logout', keycloak2, res.data);

				keycloak2.init({
					onLoad: 'check-sso',
					silentCheckSsoRedirectUri: window.location.origin + '/sso/silent-check-sso.html',
					responseMode: "query"
				}).then(async (authenticated) => {
					console.debug('authenticated', authenticated);

					if (authenticated) {
						await useApi(`${endpoints.get('_post_hapi_auth_logout_api')}`, {
							method: 'POST',
							body: {success_url: "/uporabnik/"},
						});
						await apiToken.generate();

						var logoutUrl = keycloak2.createLogoutUrl();
						keycloak2.logout({
							locale: 'sl',
							redirectUri: `${config?.host}/?logout=1`
						});
					} else {
						console.debug('not authenticated')
					}
				}).catch(error => {
					console.debug('failed to initialize' + error);
				})
			} else {
				console.debug('res success is false');
				//await navigateTo({path: '/'});
			}
		});
	});
</script>
